import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[invoiceFormatterDirective]',
})
export class InvoiceFormatterDirective {
  @Output() valueChange = new EventEmitter<string>();

  constructor(private el: ElementRef<HTMLInputElement>, private renderer: Renderer2) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const raw = input.value || '';
    const caret = input.selectionStart ?? raw.length;

    // dígitos sin formatear, max 13 (5 + 8)
    const digits = raw.replace(/\D/g, '').slice(0, 13);
    const formatted = this.formatFromDigits(digits, false);

    this.renderer.setProperty(input, 'value', formatted);

    // Mantener el cursor según # de dígitos antes del caret original
    const digitsBeforeCaret = (raw.slice(0, caret).match(/\d/g) || []).length;
    const newCaret = this.caretFromDigitIndex(formatted, digitsBeforeCaret);

    // Reposicionar caret (después de que el valor se setea)
    setTimeout(() => input.setSelectionRange(newCaret, newCaret));
    this.valueChange.emit(formatted);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const input = this.el.nativeElement;
    const txt = event.clipboardData?.getData('text/plain') || '';
    const digits = txt.replace(/\D/g, '').slice(0, 13);
    const formatted = this.formatFromDigits(digits, false);

    this.renderer.setProperty(input, 'value', formatted);
    setTimeout(() => input.setSelectionRange(formatted.length, formatted.length));
    this.valueChange.emit(formatted);
  }

  @HostListener('blur')
  onBlur() {
    const input = this.el.nativeElement;
    const digits = input.value.replace(/\D/g, '');
    if (!digits) return;

    // En blur, completa a 5-8 con ceros a la izquierda
    const formatted = this.formatFromDigits(digits, true);
    this.renderer.setProperty(input, 'value', formatted);
    this.valueChange.emit(formatted);
  }

  private formatFromDigits(d: string, pad: boolean): string {
    let left = d.slice(0, 5);
    let right = d.slice(5, 13);

    if (pad) {
      left = left.padStart(5, '0');
      right = right.padStart(8, '0');
    }

    return right.length ? `${left}${left ? '-' : ''}${right}` : left;
  }

  private caretFromDigitIndex(formatted: string, digitCount: number): number {
    if (digitCount <= 0) return 0;
    let count = 0;
    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i])) {
        count++;
        if (count === digitCount) return i + 1;
      }
    }
    return formatted.length;
  }
}
